import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const REPORT_TYPE_SCHEMA = Object.freeze({
  LABEL: '',
  VALUE: '',
});
const RECORD = generateSchema(REPORT_TYPE_SCHEMA);
const KEYS: any = generateKeys(REPORT_TYPE_SCHEMA);

export class ReportType extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get value(): string {
    return this.get(KEYS.VALUE);
  }
}
